import {
    categoryCountryCode,
    categoryNodeId,
    nextLevelCategoryId,
    rootCategoryId,
} from 'configuration/fieldCreators/categoryPerformance'
import {
    reportStartDateMonth,
    reportStartDateWeek,
    reportStartDateYear,
    reportStartDateQuarter,
} from 'configuration/fieldCreators/date'
import { CATEGORY, COUNTRIES, DATES, METRIC_FILTERS } from 'const/filters'

export const CATEGORY_PERFORMANCE_FACTS_SPECIAL_RENDERER = [
    categoryNodeId({ isVisible: true, dataIndex: ['category', 'name'] }),
    rootCategoryId({ isVisible: true, dataIndex: ['root_category', 'name'] }),
    nextLevelCategoryId({
        isVisible: true,
        dataIndex: ['next_level_category', 'name'],
    }),
    categoryCountryCode({ isVisible: true }),
    reportStartDateMonth({ id: 'report_start_date_month', isVisible: true }),
    reportStartDateWeek({ id: 'report_start_date_week', isVisible: true }),
    reportStartDateYear({ id: 'report_start_date_year', isVisible: true }),
    reportStartDateQuarter({
        id: 'report_start_date_quarter',
        isVisible: true,
    }),
]

export const CATEGORY_PERFORMANCE_FACTS_FILTERS = [
    DATES,
    COUNTRIES,
    METRIC_FILTERS,
    CATEGORY,
]
